import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=f74ba384&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f74ba384')) {
      api.createRecord('f74ba384', component.options)
    } else {
      api.reload('f74ba384', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=f74ba384&", function () {
      api.rerender('f74ba384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z1ziZpc0DrW/JS/imageCarousel.vue"
export default component.exports